




























import { Component, Vue, Prop } from 'vue-property-decorator';

import { Store } from '@/enums/Store';

import { Member } from '@/util/Member';

import AdditionalInformation from '@/components/Member/AdditionalInformation.vue';
import BaseUserForm from '@/components/Form/BaseUserForm.vue';
import TicketCategorySelection from '@/components/Member/TicketCategorySelection.vue';
import Validatable from '@/components/Validatable.vue';

import { namespace } from 'vuex-class';
import { EventInterface } from '@/types/Event';

const MEMBER = namespace(Store.MEMBER);
const App = namespace(Store.APP);

@Component({
  components: { TicketCategorySelection, BaseUserForm, AdditionalInformation }
})
export default class MemberFormItem extends Validatable {
  @Prop({ required: true }) member!: Member;
  @Prop({ required: true }) index!: number;

  @MEMBER.Action('updateMember') updateMember!: (member: Member) => void;
  @MEMBER.State('members') members!: Member[];
  @App.State('promoterId') promoterId!: number;

  collapsed = false;

  async mounted() {
    await this.validate(true);
    if (this.members.length > 1) {
      this.collapsed = true;
    }
  }

  set memberSync(member: Member) {
    this.updateMember(member);
  }

  get memberSync() {
    return this.member;
  }

  get showContent() {
    if (!this.valid && this.validated && !this.collapsed) {
      return true;
    }

    if (!this.collapsed) {
      return true;
    }

    if (!this.validated) {
      return false;
    }

    if (this.valid) {
      return false;
    }

    if (this.collapsed) {
      return false;
    }

    return true;
  }

  get name() {
    if (this.promoterId == 850) {
      return this.getJumiMemberFormName();
    }
    return this.getK5NameMemberFormName();
  }

  getK5NameMemberFormName() {
    if (!this.member.firstname && !this.member.lastname) {
      return this.$t('member', { index: this.index + 1 });
    }

    return `${this.member.firstname || ''} ${this.member.lastname || ''}`;
  }

  getJumiMemberFormName() {
    if (this.index === 0) {
      if (!this.member.firstname && !this.member.lastname) {
        return 'Gruppenleiter / -in';
      }

      return `${this.member.firstname || ''} ${this.member.lastname || ''}`;
    }
    if (!this.member.firstname && !this.member.lastname) {
      return this.$t('member', { index: this.index });
    }

    return `${this.member.firstname || ''} ${this.member.lastname || ''}`;
  }
}
